import { useState } from "react";
import { MdEdit } from 'react-icons/md';
import { useMutation } from "@apollo/client";
import { GET_POST } from "../queries/postQueries";
import { UPDATE_POST } from "../mutations/postMutations";
import { toast } from 'react-hot-toast';

export default function EditPostForm({ post }) {
  const [content, setContent] = useState(post.content)

  const [updatePost] = useMutation(UPDATE_POST, {
    variables: { id: post.id, content },
    refetchQueries: [{ query: GET_POST, variables: { id: post.id } }],
    onCompleted: () => {
      toast.success('post got editied successfully')
    },
    onError: (error) => {
      toast.error(error.message)
    }
  })

  const onSubmit = (e) => {
    e.preventDefault()

    if (!content) {
      return alert("Please fill out all fields")
    }

    updatePost(content)
  }

  return (
    <div className="mt-5">
      <hr className="text-violet" />
      <div className="rfs-3 mb-3 text-center">Edit Post</div>

      <form onSubmit={onSubmit}>
        <div className="mb-3">
          <label className="form-label rfs-5">Content</label>
          <textarea
            className="form-control rfs-6"
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          ></textarea>
        </div>

        <button type="submit" className="btn btn-violet">
          <div className='d-flex align-items-center rfs-5'>
            <MdEdit className="icon me-2" />
            <span>Edit</span>
          </div>
        </button>
      </form>
    </div>
  )
}
